import styled, { css } from 'styled-components';
import PopperUnstyled from '@mui/base/PopperUnstyled';

export const SelectPopper = styled(PopperUnstyled)(
  ({ theme }) => css`
    z-index: ${theme.layers.popper};
  `,
);
